/* Tysk katalog for locale-no.js (del 1 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'common.save': 'Änderungen speichern',
  'common.saving': 'Wird gespeichert...',
  'common.cancel': 'Abbrechen',
  'common.hoursMinutes': '{h} Std. {m} Min.',
  'common.delete': 'Löschen',
  'common.confirmTitle': 'Bist du sicher?',
  'common.continue': 'Weiter',
  'account.view': 'Kontoansicht',
  'account.relevant': 'Relevante',
  'account.all': 'Alle',
  'account.favorites': 'Favoriten',
  'account.addFavorite': 'Zu Favoriten hinzufügen',
  'account.removeFavorite': 'Aus Favoriten entfernen',
  'account.searchHint': 'Name, Nummer oder z. B. 5x suchen',
  'common.working': 'Wird bearbeitet...',
  'common.close': 'Schließen',
  'common.on': 'An',
  'common.off': 'Aus',
  'common.active': 'Aktiv',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'month.short.1': 'Jan.',
  'month.short.2': 'Feb.',
  'month.short.3': 'März',
  'month.short.4': 'Apr.',
  'month.short.5': 'Mai',
  'month.short.6': 'Juni',
  'month.short.7': 'Juli',
  'month.short.8': 'Aug.',
  'month.short.9': 'Sep.',
  'month.short.10': 'Okt.',
  'month.short.11': 'Nov.',
  'month.short.12': 'Dez.',
  'ui.summary.title': 'Zusammenfassung',
  'ui.summary.exVat': 'Summe ohne MwSt.',
  'ui.summary.vat': 'MwSt.',
  'ui.summary.total': 'Gesamtsumme',
  'ui.more': 'Mehr',
  'ui.filter': 'Filter',
  'ui.filterReset': 'Filter zurücksetzen',
  'ui.filterChoices': 'Filteroptionen',
  'ui.period': 'Zeitraum',
  'ui.from': 'Von',
  'ui.to': 'Bis',
  'ui.fromMonth': 'Von Monat',
  'ui.toMonth': 'Bis Monat',
  'ui.fromDate': 'Von Datum',
  'ui.toDate': 'Bis Datum',
  'ui.today': 'Heute',
  'ui.wholeYearTitle': 'Gesamtes Jahr {year}',
  'ui.quick.wholeYear': 'Ganzes Jahr',
  'ui.quick.ytd': 'Seit Jahresbeginn',
  'ui.quick.thisTerm': 'Dieser Zeitraum',
  'ui.quick.lastYear': 'Vorjahr',
  'ui.term': 'Zeitraum {n}',
  'ui.amountSearch': 'Nach Betrag suchen',
  'ui.amountFrom': 'Betrag von',
  'ui.amountTo': 'Betrag bis',
  'list.search': 'Suchen',
  'list.copy': 'Kopieren',
  'list.copied': 'Kopiert: {text}',
  'list.export': 'Exportieren',
  'list.download': 'Herunterladen',
  'list.downloaded': '{label} heruntergeladen',
  'list.nothingToExport': 'Keine Zeilen zum Exportieren',
  'list.downloading': '{label} wird heruntergeladen …',
  'list.upload': 'Hochladen',
  'list.add': 'Hinzufügen',
  'list.archiveTitle': 'Ins Archiv verschieben?',
  'list.archiveConfirm': 'Ins Archiv verschieben',
  'list.deleteTitle': 'Löschen?',
  'list.delete': 'Löschen',
  'list.archiveBody': 'Möchtest du {name} ins Archiv verschieben? Der Kunde wird in aktiven Kundenlisten ausgeblendet, aber Rechnungen, Zahlungen und Verlauf bleiben erhalten. Dies kann hier nicht rückgängig gemacht werden.',
  'list.deleteBody': 'Möchtest du {name} wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
  'crm.prospect': 'Interessent',
  'crm.active': 'Aktiv',
  'crm.quoteSent': 'Angebot gesendet',
  'crm.pause': 'Pausiert',
  'badge.paid': 'Ausgeglichen',
  'badge.active': 'Aktiv',
  'badge.sent': 'Gesendet',
  'badge.draft': 'Entwurf',
  'badge.created': 'Nicht gesendet',
  'badge.overdue': 'Überfällig',
  'badge.credited': 'Gutgeschrieben',
  'badge.inactive': 'Inaktiv',
  'badge.ok': 'Übermittelt',
  'badge.no': 'Nicht übermittelt',
  'badge.soon': 'Bald fällig',
  'status.draft': 'Entwurf',
  'status.created': 'Nicht gesendet',
  'status.sent': 'Gesendet',
  'status.paid': 'Bezahlt',
  'status.overdue': 'Überfällig',
  'status.credited': 'Gutgeschrieben',
  'app.loading': 'Deine Buchhaltung wird geladen…',
  'app.loadingPersonalFinance': 'Deine Privatfinanzen werden geladen…',
  'app.loadingEmployeePortal': 'Dein Mitarbeiterportal wird geladen…',
  'project.cost.field': 'Projekt',
  'project.cost.none': 'Keinem Projekt zugeordnet',
  'project.cost.billable': 'Wird an den Kunden weiterberechnet',
  'project.cost.pickTitle': 'Projekt wählen',
  'project.cost.search': 'Nach Projekt oder Kunde suchen',
  'project.cost.searchEmpty': 'Keine Projekte passen zur Suche.',
  'project.cost.toProject': 'Zum Projekt',
  'app.employeePortalVerifyTitle': 'Bestätige deine E-Mail-Adresse',
  'app.employeePortalVerifyText': 'Wir haben einen Bestätigungslink an {{email}} gesendet. Es kann einige Minuten dauern, bis er ankommt. Prüfe auch den Spam-Ordner. Öffne den Link, um fortzufahren.',
  'app.employeePortalVerifyResend': 'Link erneut senden',
  'app.employeePortalVerifySent': 'Der Bestätigungslink wurde erneut gesendet.',
  'app.employeePortalVerifyAlready': 'Die E-Mail-Adresse ist bereits bestätigt. Lade die Seite neu.',
  'app.employeePortalVerifyFailed': 'Der Bestätigungslink konnte nicht gesendet werden.',
  'app.emailVerifyCheck': 'Ich habe bestätigt',
  'app.emailVerifyConfirmed': 'Die E-Mail-Adresse ist bestätigt.',
  'app.emailVerifyNotConfirmed': 'Die E-Mail-Adresse ist noch nicht bestätigt. Öffne den Link in der E-Mail und versuche es erneut.',
  'app.emailVerifyCheckFailed': 'Die E-Mail-Adresse konnte nicht geprüft werden.',
  'app.emailVerifyInitialFailed': 'Das Konto wurde erstellt, aber der Bestätigungslink konnte nicht gesendet werden. Versuche, ihn erneut zu senden.',
  'app.placeholder.title': 'Diese Seite ist auf dem Weg',
  'app.placeholder.text': 'Wir feilen hier noch an den letzten Details. Schau bald wieder vorbei!',
  'app.nobusiness.title': 'Womit möchtest du beginnen?',
  'app.nobusiness.text': 'Du bist angemeldet, hast aber noch kein Unternehmen in Plumme.',
  'app.nobusiness.create': 'Unternehmen anlegen',
  'app.nobusiness.signOut': 'Abmelden',
  'common.signOut': 'Abmelden',
  'auth.sub.default': 'Einfache Buchhaltung für kleine Unternehmen',
  'auth.sub.forgot': 'Setze dein Passwort zurück',
  'auth.sub.sent': 'Prüfe deine E-Mails',
  'auth.sub.signup': 'Konto erstellen und Unternehmen einrichten',
  'auth.language': 'Sprache',
  'auth.invite.household': 'Du hast eine Einladung zu den Haushaltsfinanzen erhalten. Melde dich an oder erstelle ein Konto mit der E-Mail-Adresse, an die die Einladung gesendet wurde.',
  'auth.invite.business': 'Du hast eine Mandanteneinladung erhalten. Gib die E-Mail-Adresse ein, an die die Einladung gesendet wurde, dann öffnen wir die Einladung nach der Anmeldung.',
  'auth.email': 'E-Mail',
  'auth.emailPlaceholder': 'du@beispiel.de',
  'auth.password': 'Passwort',
  'auth.name': 'Name',
  'auth.namePlaceholder': 'Dein Name',
  'auth.passwordMin': 'Mindestens 6 Zeichen',
  'auth.showPassword': 'Passwort anzeigen',
  'auth.hidePassword': 'Passwort verbergen',
  'auth.remember': 'Angemeldet bleiben',
  'auth.forgot': 'Passwort vergessen?',
  'auth.signIn': 'Anmelden',
  'auth.signingIn': 'Anmeldung läuft...',
  'auth.noAccount': 'Noch kein Konto?',
  'auth.createAccount': 'Konto erstellen',
  'auth.creating': 'Wird erstellt...',
  'auth.backToLogin': 'Zurück zur Anmeldung',
  'auth.forgotCopy': 'Gib die E-Mail-Adresse ein, mit der du dich anmeldest, dann senden wir dir einen Link zum Erstellen eines neuen Passworts.',
  'auth.sendResetLink': 'Link zum Zurücksetzen senden',
  'auth.sending': 'Wird gesendet...',
  'auth.sentCopy': 'Wir haben einen Link an {email} gesendet. Folge dem Link in der E-Mail, um ein neues Passwort zu erstellen.',
  'auth.wrongEmail': 'Falsche E-Mail-Adresse? Versuche es erneut',
  'auth.error.signIn': 'Anmeldung fehlgeschlagen.',
  'auth.error.reset': 'Der Link zum Zurücksetzen konnte nicht gesendet werden.',
  'auth.error.signUp': 'Das Konto konnte nicht erstellt werden.',
  'capture.scan': 'Beleg scannen',
  'capture.toInbox': 'In den Posteingang',
  'capture.toPurchase': 'Zu Bezahlter Einkauf',
  'capture.analysisFailed': 'Der Beleg wurde hochgeladen, aber die Analyse ist fehlgeschlagen.',
  'capture.readyInPurchase': 'Der Beleg ist unter Bezahlter Einkauf bereit.',
  'capture.uploadingToInbox': 'Beleg wird in den Posteingang hochgeladen ...',
  'capture.uploadedToInbox': 'Beleg in den Posteingang hochgeladen.',
  'capture.uploadFailed': 'Der Beleg konnte nicht hochgeladen werden.',
  'capture.analysisTimedOut': 'Der Beleg wurde übermittelt. Die Analyse dauert etwas länger und läuft im Hintergrund weiter.',
  'capture.paymentDialogLoadFailed': 'Die Zahlungsoptionen konnten nicht geladen werden. Versuche es erneut.',
  'nav.home': 'Start',
  'nav.aiBookkeeper': 'AI Buchhalter',
  'nav.aiAdvisor': 'AI Berater',
  'nav.newSale': 'Neuer Verkauf',
  'nav.invoices': 'Rechnungsliste',
  'nav.otherSales': 'Sonstiger Verkauf',
  'nav.customers': 'Kunden',
  'nav.products': 'Produkte',
  'nav.projects': 'Projekte',
  'nav.subscriptions': 'Verträge',
  'nav.newPurchase': 'Neuer Einkauf',
  'nav.manualEntry': 'Freie Buchung',
  'nav.suppliers': 'Lieferanten',
  'nav.assets': 'Anlagegüter',
  'nav.inventory': 'Warenlager',
  'nav.inbox': 'Posteingang',
  'nav.incomeStatement': 'Gewinn- und Verlustrechnung',
  'nav.trialBalance': 'Summen- und Saldenliste',
  'nav.budget': 'Budget',
  'nav.filings': 'MVA-melding',
  'nav.taxReturn': 'Skattemelding',
  'nav.yearEndClosing': 'Jahresabschluss',
  'nav.annualAccounts': 'Jahresabschluss (Bericht)',
  'nav.payroll': 'Lohn',
  'nav.mileageLog': 'Fahrtenbuch',
  'nav.vouchers': 'Transaktionen',
  'nav.bank': 'Bank',
  'nav.myPage': 'Meine Seite',
  'nav.activityLog': 'Aktivitätsprotokoll',
  'nav.altinn': 'Altinn',
  'nav.settings': 'Einstellungen',
  'navgroup.sales': 'Verkauf',
  'navgroup.purchases': 'Einkauf',
  'navgroup.reports': 'Berichte',
  'navgroup.filings': 'Meldungen',
  'navgroup.employees': 'Mitarbeitende',
  'navgroup.other': 'Sonstiges',
  'navgroup.miscellaneous': 'Weiteres',
  'navgroup.ai': 'AI',
  'navgroup.settings': 'Einstellungen',
  'navhelp.home': 'Deine Startseite – Kennzahlen, Diagramme und Verknüpfungen zum Erfassen von Verkäufen und Einkäufen.',
  'navhelp.aiBookkeeper': 'SuperPlumma geht Bank, Belege, MwSt. und Fristen durch und macht Vorschläge. Du prüfst und genehmigst, bevor etwas gebucht wird.',
  'navhelp.aiAdvisor': 'Finanzberatung von SuperPlumma – Gesundheitswert, Empfehlungen, Cashflow-Prognose, Risiken und Steueroptimierung.',
  'navhelp.newSale': 'Erstelle eine neue Rechnung oder ein Angebot für einen Kunden. Der Verkauf wird automatisch gebucht.',
  'navhelp.invoices': 'Übersicht über alle Rechnungen und Angebote – Status, Fälligkeit und Zahlung.',
  'navhelp.customers': 'Dein Kundenregister. Füge Kunden, denen du Rechnungen stellst, hinzu und bearbeite sie.',
  'navhelp.products': 'Waren und Dienstleistungen, die du verkaufst, mit Preis und MwSt.-Satz – bereit zur Verwendung auf Rechnungen.',
  'navhelp.projects': 'Erfasse Stunden auf Projekte und Aktivitäten, behalte den Überblick über Erledigtes und wandle nicht abgerechnete Stunden in Rechnungsentwürfe um.',
  'navhelp.subscriptions': 'Abonnements, wiederkehrende Rechnungen und Kundenlisten mit Kontrolle über automatische Versendungen.',
  'navhelp.newPurchase': 'Erfasse einen Einkauf oder eine Lieferantenrechnung mit Beleg, Lieferant, Betrag und Konto.',
  'navhelp.manualEntry': 'Buche manuell direkt auf ein Konto, wenn du volle Kontrolle über die Buchung brauchst.',
  'navhelp.suppliers': 'Dein Lieferantenregister – Name, Organisationsnummer und Kontonummer für Auszahlungen.',
  'navhelp.assets': 'Anlagegüter und dauerhafte Werte, die über die Zeit abgeschrieben werden.',
  'navhelp.inventory': 'Inventur und der Wert deines Warenbestands. Dokumentiere die Zählung und buche die Bestandsveränderung.',
  'navhelp.inbox': 'Eingegangene, aber noch nicht gebuchte Belege. Zieh sie auf die richtige Buchung.',
  'navhelp.incomeStatement': 'Erträge minus Aufwendungen – zeigt, ob das Unternehmen Gewinn macht.',
  'navhelp.trialBalance': 'Salden aller Konten – die Grundlage deiner Finanzberichte.',
  'navhelp.budget': 'Erstelle ein Budget und verfolge, wie du im Vergleich zu deinen Zielen liegst.',
  'navhelp.filings': 'Prüfe die MwSt.-Grundlage für jeden Zeitraum. Die Meldung selbst wird bei Skatteetaten eingereicht.',
  'navhelp.taxReturn': 'Entwurf der skattemelding auf Basis der Buchhaltung – prüfe die Zahlen, bevor du sie bei Skatteetaten einreichst.',
  'navhelp.yearEndClosing': 'Schritt für Schritt durch alles, was zum Abschließen des Geschäftsjahres nötig ist.',
  'navhelp.annualAccounts': 'Ergebnis, Bilanz, Anhang und Unterzeichnung. Der Jahresabschluss wird außerhalb von Plumme beim Regnskapsregisteret eingereicht.',
  'navhelp.payroll': 'Lohnlauf durchführen, Lohnabrechnungen erstellen und Lohn buchen. Die A-melding wird außerhalb von Plumme übermittelt.',
  'navhelp.mileageLog': 'Erfasse dienstliche Fahrten und sieh Kilometer und Abzüge für das Jahr.',
  'navhelp.vouchers': 'Gesamtübersicht über gebuchte Transaktionen und zugehörige Belege – suchen und wiederfinden.',
  'navhelp.bank': 'Lade Kontoauszüge hoch und stimme die Bankkonten mit der Buchhaltung ab.',
  'navhelp.myPage': 'Dein eigenes Profil und deine Benutzereinstellungen.',
  'navhelp.activityLog': 'Vollständiger Verlauf, was in der Buchhaltung getan wurde und von wem.',
  'navhelp.altinn': 'Abkürzung zu Übermittlungen und Post in Altinn.',
  'navhelp.settings': 'Einstellungen für das Unternehmen, die Buchhaltung und die App.',
  'navhelp.fallback': '{label} öffnen.',
  'route.home': 'Start',
  'route.newSale': 'Neuer Verkauf',
  'route.newSaleliste': 'Rechnungsliste',
  'route.customers': 'Kunden',
  'route.products': 'Produkte',
  'route.projects': 'Projekte',
  'route.aiBookkeeper': 'AI Buchhalter',
  'route.aiAdvisor': 'AI Berater',
  'route.newPurchase': 'Bezahlter Einkauf',
  'route.manualEntry': 'Freie Buchung',
  'route.vouchers': 'Transaktionen',
  'route.suppliers': 'Lieferanten',
  'route.assets': 'Anlagegüter',
  'route.filings': 'Meldungen',
  'route.inbox': 'Posteingang',
  'route.documentation': 'Dokumentation',
  'route.mileageLog': 'Fahrtenbuch',
  'route.bank': 'Bank',
  'route.altinn': 'Altinn',
  'route.settings': 'Einstellungen',
  'route.otherSales': 'Sonstige Verkäufe',
  'route.subscriptions': 'Verträge',
  'route.incomeStatement': 'Gewinn- und Verlustrechnung',
  'route.trialBalance': 'Summen- und Saldenliste',
  'route.budget': 'Budget',
  'route.payroll': 'Lohn',
  'route.taxReturn': 'Skattemelding',
  'route.yearEndClosing': 'Jahresabschluss',
  'route.annualAccounts': 'Jahresabschluss (Bericht)',
  'route.myPage': 'Meine Seite',
  'route.employeePortal': 'Mitarbeiterportal',
  'route.activityLog': 'Aktivitätsprotokoll',
  'route.personalFinance': 'Privatfinanzen',
  'shell.openMenu': 'Menü öffnen',
  'shell.closeMenu': 'Menü schließen',
  'shell.collapseMenu': 'Menü einklappen',
  'shell.showLabels': 'Menütext anzeigen',
  'shell.hideLabels': 'Menütext ausblenden',
  'shell.designSystem': 'Designsystem ↗',
  'shell.customizeMenu': 'Menü anpassen',
  'shell.customizeHelpTitle': 'Menü anpassen',
  'shell.customizeHelp': 'Wähle, welche Seiten im Seitenmenü angezeigt werden. Blende die aus, die du nicht nutzt, damit das Menü übersichtlich bleibt.',
  'shell.customizeTitle': 'Seitenmenü anpassen',
  'shell.customizeVisible': '{visible} von {total} sichtbar',
  'shell.customizeLead': 'Schalte Seiten aus, die du nicht nutzt, dann werden sie im Seitenmenü ausgeblendet. Du kannst sie jederzeit wieder einschalten.',
  'shell.customizeAllPages': 'Alle Seiten',
  'shell.customizeAiMode': 'AI-Modus',
  'shell.customizeAlwaysOn': 'Immer an',
  'shell.customizeDone': 'Fertig',
  'shell.camCapture': 'Beleg fotografieren',
  'shell.camHelp': 'Fotografiere einen Beleg mit der Kamera und lade ihn direkt in den Posteingang oder als neuen Einkauf.',
  'shell.moreOptions': 'Weitere Optionen',
  'shell.search': 'Suchen',
  'shell.searchAll': 'Alles durchsuchen',
  'shell.searchHelp': 'Durchsuche das aktive Unternehmen — Kunden, Rechnungen, Produkte, Belege, Projekte, Seiten und Hilfe. Tippe, um die Suche zu öffnen (Tastenkürzel: Ctrl/⌘+K).',
  'shell.searchPlaceholderLong': 'Alles durchsuchen — Rechnungen, Kunden, Belege…',
  'shell.searchEnterHint': 'um alle Treffer zu sehen',
  'shell.companyHelpTitle': 'Unternehmen oder Arbeitgeber wählen',
  'shell.companyHelp': 'Wechsle zwischen den Buchhaltungen, die du führst, und den Arbeitgebern, bei denen du angestellt bist. Alles in der App bezieht sich auf das gewählte Unternehmen.',
  'shell.yearHelpTitle': 'Geschäftsjahr',
  'shell.yearHelp': 'Wähle, an welchem Geschäftsjahr du arbeitest. Alle Zahlen und Meldungen beziehen sich auf das gewählte Jahr.',
  'shell.theme.helpTitle': 'Helles / dunkles Design',
  'shell.theme.help': 'Wechsle in der ganzen App zwischen hellem und dunklem Erscheinungsbild. Die Auswahl wird gespeichert.',
  'shell.theme.toLight': 'Zum hellen Design wechseln',
  'shell.theme.toDark': 'Zum dunklen Design wechseln',
  'shell.theme.light': 'Helles Design',
  'shell.theme.dark': 'Dunkles Design',
  'shell.bg.label': 'Hintergrundfarbe',
  'shell.bg.title': 'Hintergrundfarbe für diese Seite',
  'shell.bg.help': 'Wähle die Hintergrundfarbe nur für diese Seite. Die Farbe wird pro Seite gespeichert.',
  'shell.bg.menuTitle': 'Hintergrundfarbe · diese Seite',
  'shell.bg.default': 'Pflaume',
  'shell.bg.mint': 'Mint',
  'shell.bg.varm': 'Warm',
  'shell.bg.sky': 'Blau',
  'shell.bg.rose': 'Rosé',
  'shell.bg.skog': 'Wald',
  'skin.title': 'Erscheinungsbild',
  'skin.standard': 'Standard',
  'skin.standardSub': 'Plumme',
  'skin.klassisk': 'Klassisch',
  'skin.klassiskSub': 'Schlicht',
  'shell.client.employers': 'Deine Arbeitgeber',
  'shell.client.employer': 'Arbeitgeber',
  'shell.client.employee': 'Mitarbeiter',
  'shell.client.private': 'Privat',
  'shell.client.firm': 'Buchhaltungsbüro',
  'shell.client.firmSub': 'Mandantenübersicht und Abstimmung',
  'rf.firm': 'Buchhaltungsbüro',
  'rf.role.owner': 'Inhaber',
  'rf.role.admin': 'Administrator',
  'rf.role.employee': 'Mitarbeiter',
  'rf.group.firm': 'Buchhalter',
  'rf.group.team': 'Teamchat',
  'rf.group.other': 'Sonstiges',
  'rf.nav.clients': 'Mandantenübersicht',
  'rf.nav.reconciliation': 'Abstimmung',
  'rf.nav.control': 'Kontrolle',
  'rf.nav.teamchat': 'Teamchat',
  'rf.nav.members': 'Mitarbeiter',
  'rf.nav.clientList': 'Mandanten',
  'rf.client.pageBody': 'Verknüpfe das Büro mit seinen Mandanten und weise Mitarbeiter den Aufträgen zu.',
  'rf.client.addTitle': 'Mandanten verknüpfen',
  'rf.client.addBody': 'Der Mandant braucht ein Plumme-Konto für sein Unternehmen. Das Büro erhält erst Zugriff, wenn der Mandant zugestimmt hat.',
  'rf.client.billedTo': 'Wer bezahlt',
  'rf.client.billedToClient': 'Der Mandant bezahlt selbst',
  'rf.client.billedToFirm': 'Das Büro bezahlt',
  'rf.client.request': 'Anfrage senden',
  'rf.client.requesting': 'Wird gesendet …',
  'rf.client.requested': 'Die Anfrage wurde an den Mandanten gesendet',
  'rf.avst.noClient': 'Wähle zuerst einen Mandanten',
  'rf.avst.allClients': 'Alle Mandanten',
  'rf.avst.thisClient': 'Dieser Mandant',
  'rf.avst.noClientBody': 'Die Abstimmung gilt jeweils für einen Mandanten. Öffne einen Mandanten aus der Mandantenübersicht, dann folgt der Abstimmungsordner mit.',
  'rf.client.requestedMailFailed': 'Die Anfrage wurde gesendet, aber die E-Mail-Benachrichtigung konnte nicht zugestellt werden. Der Mandant sieht sie bei der nächsten Anmeldung.',
  'rf.client.requestedNoRecipient': 'Die Anfrage wurde gesendet, aber das Unternehmen hat keinen Inhaber oder Administrator, der benachrichtigt werden kann. Kontaktiere den Mandanten selbst.',
  'rf.client.noneTitle': 'Noch keine Mandanten',
  'rf.client.noneBody': 'Verknüpfe das Büro über die Organisationsnummer mit einem Mandanten. Der Mandant muss zustimmen, bevor ihr Zugriff erhaltet.',
  'rf.client.pendingBody': 'Der Mandant muss die Anfrage in seinem eigenen Plumme-Konto annehmen. Bis dahin hat niemand im Büro Zugriff.',
  'rf.client.assignWho': 'Dem Auftrag zuweisen',
  'rf.client.assignPick': 'Mitarbeiter wählen',
  'rf.client.assignRole': 'Rolle im Auftrag',
  'rf.client.assign': 'Zuweisen',
  'rf.client.assigned': 'Der Mitarbeiter wurde dem Mandanten zugewiesen',
  'rf.client.end': 'Auftrag beenden',
  'rf.client.ended': 'Der Auftrag wurde beendet',
  'rf.client.endConfirm': 'Auftrag für {name} beenden? Die Zugriffe, die das Büro seinen Mitarbeitern gewährt hat, werden gleichzeitig entzogen.',
  'fe.title': 'Ein Buchhaltungsbüro bittet um Zugriff',
  'fe.theFirm': 'Das Büro',
  'fe.body': 'Wenn du zustimmst, erhalten die Mitarbeiter, die das Büro dem Auftrag zuweist, Zugriff auf deine Buchhaltung. Du kannst die Zusammenarbeit jederzeit beenden.',
  'fe.billedToFirm': 'Das Büro bezahlt das Abonnement',
  'fe.billedToClient': 'Du bezahlst das Abonnement selbst',
  'fe.accept': 'Zugang gewähren',
  'fe.accepting': 'Wird angenommen …',
  'fe.accepted': '{firm} hat jetzt Zugang zur Buchhaltung.',
  'fe.decline': 'Ablehnen',
  'fe.declined': 'Die Anfrage wurde abgelehnt.',
  'fi.title': 'Du wurdest als Mitarbeiter eingeladen',
  'fi.theFirm': 'das Büro',
  'fi.body': 'Die Einladung gibt dir Zugang zum Büro selbst. Zugang zu einzelnen Mandanten erhältst du erst, wenn das Büro dich einem Auftrag zuweist.',
  'fi.verifyFirst': 'Bestätige zuerst deine E-Mail-Adresse. Wir haben einen neuen Bestätigungslink gesendet.',
  'fi.accept': 'Beitreten',
  'fi.accepting': 'Trete bei …',
  'fi.accepted': 'Du bist jetzt Mitarbeiter bei {firm}.',
  'fi.acceptFailed': 'Die Einladung konnte nicht angenommen werden.',
});
